/* eslint-disable */
import pageLocalesData from './page-locales-data.js';
import _ from 'lodash';
import mergeLocalesData from '@src/global-locales/utils/merge-locales-data.js';

/**
 * @returns {pageLocalesData}
 */
const getPageLocalesData = () => {
  return mergeLocalesData(pageLocalesData);
};
/**
 *
 * @param path {string}
 * @param [args] {any}
 * @return  string
 */
const getLocales = (path, args) => {
  if (!path) {
    return 'place enter path';
  }
  const localesData = getPageLocalesData();
  const currentLocale = _.get(localesData, path) || '';
  const replaceArgsList = currentLocale.match(/\{([^}]+)\}/gi) || [];
  let replaceList = {};
  if (typeof args === 'object') {
    replaceList = Object.keys(args).reduce((list, key) => {
      return { ...list, [`{${key}}`]: args[key] };
    }, {});
  }
  return replaceArgsList.reduce((text, key) => {
    if (typeof text.replaceAll === 'function') {
      return text.replaceAll(key, replaceList[key] || '');
    } else {
      return text.replace(new RegExp(key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), replaceList[key] || '');
    }
  }, currentLocale || '');
};

/**
 *
 * @param path {string}
 * @param [args] {any}
 * @return {JSX.Element}
 */
const getLocalesForHtml = (path, args) => {
  const text = getLocales(path, args);
  return <span dangerouslySetInnerHTML={{ __html: text }}></span>;
};
//"{second} {hahaha}（s）后自动关闭".match(/\{([^}]+)\}/ig)

export default getPageLocalesData;
export { getLocales, getLocalesForHtml };
